import {
    ADD_BATCH,
    CHANGE_BATCH_CURRENT_PAGE,
    CHANGE_PROGRESS,
    REMOVE_SAMPLE_BATCH,
    UPDATE_ALL_BATCHES,
    UPDATE_AVAILABLE_BATCH_STATUSES_BY_VALUE,
    UPDATE_BATCH,
    UPDATE_BATCHES,
    UPDATE_CASES_WITH_MISSING_SAMPLES,
    UPDATE_MISSING_SAMPLES,
    UPDATE_SAMPLE_BATCH,
    UPDATE_SAMPLE_BATCH_LIST,
    UPDATE_BATCH_FILES,
    FULLFILL_BATCH
} from "./available";

import vue from 'vue'
import _ from 'lodash'

export default {
    [CHANGE_PROGRESS](state, {context, value}) {
        state.progress[context] = value
    },
    [UPDATE_BATCHES](state, {batches, total}) {
        state.batches = batches
        state.totalBatches = total
    },
    [UPDATE_ALL_BATCHES](state, batches) {
        state.allBatches = batches
    },
    [UPDATE_BATCH](state, batch) {
        const batchIndex = _.findIndex(state.batches, (b) => {
            return b.id === batch.id
        })

        if (batchIndex < 0) {
            return
        }

        vue.set(state.batches, batchIndex, batch)
    },
    [ADD_BATCH](state, batch) {
        state.batches.unshift(batch)
        state.totalBatches++
    },
    [UPDATE_AVAILABLE_BATCH_STATUSES_BY_VALUE](state, statusesByValue) {
        state.availableBatchStatusesByValue = statusesByValue
    },
    [UPDATE_SAMPLE_BATCH_LIST](state, {batchId, sampleBatchList}) {
        state.sampleBatchesByBatchId[batchId] = _.keyBy(sampleBatchList, 'positionInBatch')
    },
    [CHANGE_BATCH_CURRENT_PAGE](state, page) {
        state.pagination.page = page
    },
    [UPDATE_SAMPLE_BATCH](state, updatedSampleBatch) {
        state.sampleBatchesByBatchId = {
            ...state.sampleBatchesByBatchId,
            [updatedSampleBatch.batchId]: {
                ...state.sampleBatchesByBatchId[updatedSampleBatch.batchId],
                [updatedSampleBatch.positionInBatch]: updatedSampleBatch
            }
        }

        const samplesBatchCount = _.keys(state.sampleBatchesByBatchId[updatedSampleBatch.batchId]).length

        const batchIndex = _.findIndex(state.batches, (b) => {
            return b.id === updatedSampleBatch.batchId
        })

        if (batchIndex < 0) {
            return
        }

        vue.set(state.batches, batchIndex, {
            ...state.batches[batchIndex],
            samplesCount: samplesBatchCount
        })
    },
    [REMOVE_SAMPLE_BATCH](state, {position, batchId}) {
        state.sampleBatchesByBatchId = {
            ...state.sampleBatchesByBatchId,
            [batchId]: _.omit(state.sampleBatchesByBatchId[batchId], position)
        }

        const samplesBatchCount = _.keys(state.sampleBatchesByBatchId[batchId]).length

        const batchIndex = _.findIndex(state.batches, (b) => {
            return b.id === batchId
        })

        if (batchIndex < 0) {
            return
        }

        vue.set(state.batches, batchIndex, {
            ...state.batches[batchIndex],
            samplesCount: samplesBatchCount
        })
    },
    [UPDATE_MISSING_SAMPLES](state, missingSamples) {
        state.missingSamples = missingSamples
    },
    [UPDATE_CASES_WITH_MISSING_SAMPLES](state, cases) {
        state.casesWithMissingSamples = cases
    },
    [UPDATE_BATCH_FILES] (state, {batchId, files}) {
        let batchIndex = _.findIndex(state.batches, (b) => {
            return b.id === batchId
        })

        if (batchIndex < 0) {
            return
        }

        let batches = _.cloneDeep(state.batches)

        batches[batchIndex].files = files

        state.batches = batches
    },
    [FULLFILL_BATCH] (state, batch) {
        let batchIndex = _.findIndex(state.batches, (b) => {
            return b.id === batch.id
        })

        if (batchIndex < 0) {
            return
        }

        let batches = _.cloneDeep(state.batches)
        batches[batchIndex] = batch

        state.batches = batches
    }
}